import React from "react";

import { useTranslation, Trans } from "react-i18next";

import control from '../../img/MarketsCrypto/control.png'
import Fade from "react-reveal/Fade";

function ControlRisk () {

    const { t } = useTranslation();
      
    return(
        <div className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative flex flex-col-reverse items-center xl:flex-row justify-between">
                <img src={control} alt="" className="mt-[50px] xl:mt-0"/>
                <div className="xl:max-w-[639px]">
                    <p className="open-sans text-[28px] xl:text-[45px] font-[700] text-[#0C2780] spantext2"><Trans>{t('marketscrypto.12')}</Trans></p>
                    <p className="text-[14px] xl:text-[16px] font-[300] text-[#0C2780] mt-[25px]">{t('marketscrypto.13')}</p>
                </div>
            </div>
        </div>
    );
}

export default ControlRisk;